// extracted by mini-css-extract-plugin
export default {"products":"Nv-z","card":"Ov-z","oosMessaging":"Pv-z"};